import { GridLegacy } from '@mui/material';
import config from 'config';
import { ALL_FEATURE_IDS } from 'constants/appConstants';
import { useAppAccessContext } from 'contexts/AppAccessContext';
import { OrgPartType } from 'types/clientV2/parts';
import ClickableBox from 'ui-component/CreateNewOrgPartDialog/components/ClickableBox';
import { PartTypesDefinitions } from 'ui-component/CreateNewOrgPartDialog/constants';

type PartTypeSelectorProps = {
  partTypeToCreate: OrgPartType;
  setPartTypeToCreate: (id: OrgPartType) => void;
};

const PartTypeSelector = ({
  partTypeToCreate,
  setPartTypeToCreate,
}: PartTypeSelectorProps) => {
  const { hasFeaturePermission } = useAppAccessContext();
  const simplePartCreationFeatureEnabled = hasFeaturePermission(
    ALL_FEATURE_IDS.SIMPLE_PART_CREATION
  );

  if (simplePartCreationFeatureEnabled) {
    return (
      <GridLegacy container direction="row">
        <GridLegacy item xs={6}>
          <ClickableBox
            onClick={(id) => setPartTypeToCreate(id)}
            boxProps={PartTypesDefinitions[OrgPartType.OTS]}
            isSelected={partTypeToCreate === OrgPartType.OTS}
            sx={{
              borderTopLeftRadius: config.borderRadius,
              borderBottomLeftRadius: config.borderRadius,
            }}
          />
        </GridLegacy>
        <GridLegacy item xs={6}>
          <ClickableBox
            onClick={(id) => setPartTypeToCreate(id)}
            boxProps={PartTypesDefinitions[OrgPartType.CUSTOM]}
            isSelected={partTypeToCreate === OrgPartType.CUSTOM}
            sx={{
              borderTopRightRadius: config.borderRadius,
              borderBottomRightRadius: config.borderRadius,
            }}
          />
        </GridLegacy>
      </GridLegacy>
    );
  }
  return (
    <GridLegacy container direction="row">
      <GridLegacy item xs={6} md={4}>
        <ClickableBox
          onClick={(id) => setPartTypeToCreate(id)}
          boxProps={PartTypesDefinitions[OrgPartType.OTS]}
          isSelected={partTypeToCreate === OrgPartType.OTS}
          sx={{ borderTopLeftRadius: config.borderRadius }}
        />
      </GridLegacy>
      <GridLegacy item xs={6} md={4}>
        <ClickableBox
          onClick={(id) => setPartTypeToCreate(id)}
          boxProps={PartTypesDefinitions[OrgPartType.CUSTOM]}
          isSelected={partTypeToCreate === OrgPartType.CUSTOM}
        />
      </GridLegacy>
      <GridLegacy item xs={6} md={4}>
        <ClickableBox
          boxProps={PartTypesDefinitions[OrgPartType.ASSEMBLY]}
          isSelected={partTypeToCreate === OrgPartType.ASSEMBLY}
          disabled
          sx={{ borderTopRightRadius: config.borderRadius }}
        />
      </GridLegacy>
      <GridLegacy item xs={6} md={4}>
        <ClickableBox
          onClick={(id) => setPartTypeToCreate(id)}
          boxProps={PartTypesDefinitions[OrgPartType.SERVICE]}
          isSelected={partTypeToCreate === OrgPartType.SERVICE}
          sx={{ borderBottomLeftRadius: config.borderRadius }}
        />
      </GridLegacy>
      <GridLegacy item xs={6} md={4}>
        <ClickableBox
          onClick={(id) => setPartTypeToCreate(id)}
          boxProps={PartTypesDefinitions[OrgPartType.NON_STOCKED]}
          isSelected={partTypeToCreate === OrgPartType.NON_STOCKED}
        />
      </GridLegacy>
      <GridLegacy item xs={6} md={4}>
        <ClickableBox
          boxProps={PartTypesDefinitions[OrgPartType.BUNDLED]}
          isSelected={partTypeToCreate === OrgPartType.BUNDLED}
          disabled
          sx={{ borderBottomRightRadius: config.borderRadius }}
        />
      </GridLegacy>
    </GridLegacy>
  );
};

export default PartTypeSelector;
